import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useNavigate } from 'react-router-dom';

function CrmMyPoints(props) {

    const navigate = useNavigate();
    
    const handleClick = (event) => {
        navigate("/crm/my-points");
    };

    return (
        <Tooltip title="My Points" placement="top">
            <IconButton
                className="w-40 h-40"
                aria-controls="font-size-menu"
                aria-haspopup="true"
                size="large"
                onClick={handleClick}
            >
                <Icon>assistant</Icon>
            </IconButton>
        </Tooltip>
    );
}

export default CrmMyPoints;
